import React, { useState, useEffect } from "react"
import Logo from "../assets/images/logo-black.svg"
import BookADemo from "./BookADemo"
import { PhoneFilled, MailOutlined } from "@ant-design/icons"
import { useHistory } from "react-router-dom"

function Footer() {
  const [visible, setVisible] = useState(false)

  const history = useHistory()

  return history.location.pathname.includes("/prescription-audit") ? null : (
    <footer id="footer">
      <img src={Logo} alt="logo" className="footerLogo" />
      <button onClick={() => setVisible(true)} className="bookDemoButton bookDemoButtonBlue">
        Send Your Query
      </button>
      <section className="footerGrid">
        <span className="footerContact">
          <span>Contact us:</span> &nbsp;
          <MailOutlined />
          &nbsp;<a href="mailto:info@thedoc.pro">info@thedoc.pro</a>&nbsp;&nbsp;&nbsp;
          <PhoneFilled />
          &nbsp;<a href="tel:+917406197778">+91-7406197778</a>
        </span>
        <span className="copyright">
          <span
            className="privacy"
            onClick={() => {
              history.push("/privacy-policy")
            }}
          >
            Privacy Policy
          </span>
          <span>Copyright © 2022-2023 All Rights Reserved</span>
        </span>
      </section>
      <BookADemo visible={visible} setVisible={setVisible} />
    </footer>
  )
}

export default Footer
